import React from "react"
import { usePageAssets } from "hooks/usePageAssets"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import SplitContainer from "components/ui/Layout/SplitContainer"

function SelfServeVisualizationSection() {
  const { getAsset } = usePageAssets()
  const illustration = getAsset("internal-tooling-self-serve-visualization")
  return (
    <Container section>
      <SplitContainer
        className="py-10 lg:py-20 xl:py-32 2xl:py-40"
        image={illustration}
        imageClassName="mt-8 md:mt-0 max-w-2xl mx-auto"
        reversed
      >
        <Heading
          label="Self-Serve Visualization"
          title="Scale chart and dashboard creation"
          subtitle={
            <>
              Deliver interactive analytics that your team desires without
              adding workload to the data team. With Preset’s no-code viz
              builder and explorer, business teams can easily create custom
              charts and dashboards and explore everything from marketing
              performance metrics to product usage data.
            </>
          }
          narrow
        />
      </SplitContainer>
    </Container>
  )
}

export default SelfServeVisualizationSection
